import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetIdentification } from '../../../../state';

const ModelEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetIdentification({ model: event.target.value }));
  };

  return (
    <TextField
      label="Model"
      size="small"
      fullWidth
      value={currentAsset?.model || ''}
      onChange={handleChange}
    />
  );
};

export default ModelEdit;
